import {AxiosError} from 'axios';

import ROUTES from 'routes';

import {AppAlertTypesEnum} from 'types/global';

export const APP_ERRORS = {
    badRequest: {
        codes: [400],
        alert: AppAlertTypesEnum.Basic,
        redirect: null,
    },
    notAccess: {
        codes: [403],
        redirect: ROUTES.errorPage.path,
        alert: null,
    },
    notFound: {
        codes: [404],
        redirect: ROUTES.errorPage.path,
        alert: null,
    },
    mismatch: {
        codes: [409],
        redirect: null,
        alert: AppAlertTypesEnum.Mismatch,
    },
    internalProblem: {
        codes: [0, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, AxiosError.ERR_NETWORK],
        redirect: ROUTES.errorPage.path,
        alert: null,
    },
};
